<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8378_29142)">
      <path d="M11.74 1.5H20.26C21.25 1.5 22.19 1.89 22.89 2.59L28.91 8.61C29.61 9.31 30 10.25 30 11.24V19.76C30 20.75 29.61 21.69 28.91 22.39L22.89 28.41C22.19 29.11 21.25 29.5 20.26 29.5H11.74C10.75 29.5 9.81 29.11 9.11 28.41L3.09 22.39C2.39 21.69 2 20.75 2 19.76V11.24C2 10.25 2.39 9.31 3.09 8.61L9.11 2.59C9.81 1.89 10.75 1.5 11.74 1.5Z"
            fill="url(#paint0_linear_8378_29142)"
      />
      <path d="M11.74 1.5H20.26C21.25 1.5 22.19 1.89 22.89 2.59L28.91 8.61C29.61 9.31 30 10.25 30 11.24V19.76C30 20.75 29.61 21.69 28.91 22.39L22.89 28.41C22.19 29.11 21.25 29.5 20.26 29.5H11.74C10.75 29.5 9.81 29.11 9.11 28.41L3.09 22.39C2.39 21.69 2 20.75 2 19.76V11.24C2 10.25 2.39 9.31 3.09 8.61L9.11 2.59C9.81 1.89 10.75 1.5 11.74 1.5Z"
            fill="url(#paint1_linear_8378_29142)"
      />
      <path d="M11.74 1.5H20.26C21.25 1.5 22.19 1.89 22.89 2.59L28.91 8.61C29.61 9.31 30 10.25 30 11.24V19.76C30 20.75 29.61 21.69 28.91 22.39L22.89 28.41C22.19 29.11 21.25 29.5 20.26 29.5H11.74C10.75 29.5 9.81 29.11 9.11 28.41L3.09 22.39C2.39 21.69 2 20.75 2 19.76V11.24C2 10.25 2.39 9.31 3.09 8.61L9.11 2.59C9.81 1.89 10.75 1.5 11.74 1.5Z"
            fill="url(#paint2_linear_8378_29142)"
      />
      <path d="M11.74 1.5H20.26C21.25 1.5 22.19 1.89 22.89 2.59L28.91 8.61C29.61 9.31 30 10.25 30 11.24V19.76C30 20.75 29.61 21.69 28.91 22.39L22.89 28.41C22.19 29.11 21.25 29.5 20.26 29.5H11.74C10.75 29.5 9.81 29.11 9.11 28.41L3.09 22.39C2.39 21.69 2 20.75 2 19.76V11.24C2 10.25 2.39 9.31 3.09 8.61L9.11 2.59C9.81 1.89 10.75 1.5 11.74 1.5Z"
            fill="url(#paint3_linear_8378_29142)"
      />
      <path d="M11.74 1.5H20.26C21.25 1.5 22.19 1.89 22.89 2.59L28.91 8.61C29.61 9.31 30 10.25 30 11.24V19.76C30 20.75 29.61 21.69 28.91 22.39L22.89 28.41C22.19 29.11 21.25 29.5 20.26 29.5H11.74C10.75 29.5 9.81 29.11 9.11 28.41L3.09 22.39C2.39 21.69 2 20.75 2 19.76V11.24C2 10.25 2.39 9.31 3.09 8.61L9.11 2.59C9.81 1.89 10.75 1.5 11.74 1.5Z"
            fill="url(#paint4_linear_8378_29142)"
      />
      <path d="M11.74 1.5H20.26C21.25 1.5 22.19 1.89 22.89 2.59L28.91 8.61C29.61 9.31 30 10.25 30 11.24V19.76C30 20.75 29.61 21.69 28.91 22.39L22.89 28.41C22.19 29.11 21.25 29.5 20.26 29.5H11.74C10.75 29.5 9.81 29.11 9.11 28.41L3.09 22.39C2.39 21.69 2 20.75 2 19.76V11.24C2 10.25 2.39 9.31 3.09 8.61L9.11 2.59C9.81 1.89 10.75 1.5 11.74 1.5Z"
            fill="url(#paint5_linear_8378_29142)"
      />
      <path d="M12.57 3.5H19.43C20.42 3.5 21.36 3.89 22.06 4.59L26.91 9.44C27.61 10.14 28 11.08 28 12.07V18.93C28 19.92 27.61 20.86 26.91 21.56L22.06 26.41C21.36 27.11 20.42 27.5 19.43 27.5H12.57C11.58 27.5 10.64 27.11 9.94 26.41L5.09 21.56C4.39 20.86 4 19.92 4 18.93V12.07C4 11.08 4.39 10.14 5.09 9.44L9.94 4.59C10.64 3.89 11.58 3.5 12.57 3.5Z"
            fill="url(#paint6_linear_8378_29142)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_8378_29142"
                      x1="27.8601"
                      y1="6.47516"
                      x2="8.85076"
                      y2="27.0923"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBF9FC" />
        <stop offset="0.50095"
              stop-color="#D5C9DD"
        />
        <stop offset="1"
              stop-color="#B9B3BC"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_8378_29142"
                      x1="16"
                      y1="31.0784"
                      x2="16"
                      y2="27.1534"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8C749B" />
        <stop offset="1"
              stop-color="#8C749B"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_8378_29142"
                      x1="5.5"
                      y1="24.5"
                      x2="25"
                      y2="5"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.0424679"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_8378_29142"
                      x1="2"
                      y1="15.5"
                      x2="30"
                      y2="15.5"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.0424679"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_8378_29142"
                      x1="6"
                      y1="5.5"
                      x2="26"
                      y2="25"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.043756"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_8378_29142"
                      x1="16"
                      y1="0.5"
                      x2="16"
                      y2="29.5"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.0668103"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_8378_29142"
                      x1="29.1182"
                      y1="15.5"
                      x2="3.9981"
                      y2="15.5"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E53146" />
        <stop offset="1"
              stop-color="#CC307A"
        />
      </linearGradient>
      <clipPath id="clip0_8378_29142">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
